import { getBrowserTimezone } from '../../../lib/browser-timezone';

interface BuildNovaRequestContextOptions {
  accountUuid?: string;
  additionalContext?: Record<string, unknown>;
  classUuid?: string;
}

/**
 * Builds the per-request context shared by new messages and regenerations.
 * Function values are resolved immediately before sending so short-lived
 * credentials, such as the Graph token getter supplied by the Outlook
 * add-in, are always fresh.
 */
export async function buildNovaRequestContext({
  accountUuid,
  additionalContext = {},
  classUuid,
}: BuildNovaRequestContextOptions): Promise<Record<string, unknown>> {
  const resolvedContext = await resolveContextValues(additionalContext);

  return {
    accountUuid,
    timezone: getBrowserTimezone(),
    ...(classUuid && { classUuid }),
    ...(Object.keys(resolvedContext).length > 0 && {
      ...resolvedContext,
      additionalContext: resolvedContext,
    }),
  };
}

async function resolveContextValues(context: Record<string, unknown>): Promise<Record<string, unknown>> {
  const resolvedEntries = await Promise.all(
    Object.entries(context).map(async ([key, value]) => [key, typeof value === 'function' ? await value() : value]),
  );

  return Object.fromEntries(resolvedEntries);
}
